var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('auto-form',{attrs:{"mode":_vm.mode},model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }